import { Check } from "lucide-react";
import Avatar from "../../components/Avatar";
import { AVATAR_ART } from "../../components/AvatarIcons";
import { AVATAR_KEYS, type AvatarKey } from "../../lib/profiles";

export default function AvatarPicker({ value, onChange, name }: { value: AvatarKey; onChange: (key: AvatarKey) => void; name: string }) {
  return <div className="avatar-picker" role="radiogroup" aria-label="Picture">
    {AVATAR_KEYS.map((key) => <button
      key={key}
      type="button"
      role="radio"
      aria-checked={value === key}
      aria-label={AVATAR_ART[key].label}
      title={AVATAR_ART[key].label}
      className={value === key ? "selected" : ""}
      onClick={() => onChange(key)}
    >
      <Avatar owner={name || "New profile"} avatar={key} size={44} />
      {value === key && <span className="avatar-picker-check"><Check size={11} strokeWidth={3} /></span>}
    </button>)}
  </div>;
}
